import { render, staticRenderFns } from "./restaurant.vue?vue&type=template&id=699e1d16&scoped=true&"
import script from "./restaurant.vue?vue&type=script&lang=js&"
export * from "./restaurant.vue?vue&type=script&lang=js&"
import style0 from "./restaurant.vue?vue&type=style&index=0&id=699e1d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699e1d16",
  null
  
)

export default component.exports